import { Behavior } from '@dia-ui/abstract';

@Behavior('password-strength')
export class PasswordStrength {
  password: string;
  element : any;

  constructor(element) {
    this.element = element;
    this.password = '';
  }

  connectedCallback() {
    console.log('PasswordStrength Behavior connected to:', this.element);

    // Passwort initialisieren
    this.password = this.element.getAttribute('password') || '';
    this.renderComponent();

    // Event-Listener für 'password-change' Event
    this.element.addEventListener('password-change', (event: CustomEvent) => {
      this.password = event.detail; // Wert aus Event übernehmen
      console.log('Password updated via CustomEvent:', this.password);
      this.renderComponent();
    });
  }



  getStrength(password: string): number {
    let strength = 0;
    const minLength = 12;
    const maxLength = 50;
    const symbols = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";

    if (password.length >= minLength && password.length <= maxLength) strength += 1;
    if (/[a-z]/.test(password)) strength += 1;
    if (/[A-Z]/.test(password)) strength += 1;
    if (/[0-9]/.test(password)) strength += 1;
    if (symbols.split('').some(char => password.includes(char))) strength += 1;

    return strength;
  }

  getStrengthMessage(strength: number) {
    switch (strength) {
      case 0:
      case 1:
      case 2:
        return { message: 'schwach', color: 'red' };
      case 3:
        return { message: 'Mittel', color: 'orange' };
      case 4:
        return { message: 'Stark', color: 'yellowgreen' };
      case 5:
        return { message: 'Sehr Stark', color: 'green' };
      default:
        return { message: '', color: '' };
    }
  }

  renderComponent() {
    const strength = this.getStrength(this.password);
    const { message, color } = this.getStrengthMessage(strength);

    let passwordStrengthContainer = this.element.parentElement.querySelector('dia-password-strength');

    passwordStrengthContainer.style.width = "100%";
    passwordStrengthContainer.style.height = "min-content";
    passwordStrengthContainer.style.color = color;
    passwordStrengthContainer.style.borderTop = "2px solid " + color;
    passwordStrengthContainer.style.marginTop = "8px";
    passwordStrengthContainer.innerHTML = message;
  }
}
